// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_7zD","colBig":"styles_colBig__3TJQt","colSmall":"styles_colSmall__1Zp-A"};